import { SphereInstancedMesh } from "../threeDComponent/InstancedMesh";
import { LineSegments } from "../threeDComponent/FilledPolygon";
import * as THREE from "three";
import { colors } from "../../utils/colors";

export const PointAndLines = ({ verts, pointsProps, linesProps }) => {
  if (!verts?.length) return null;

  return (
    <>
      <SphereInstancedMesh
        objects={verts}
        setColor={() => new THREE.Color(colors.red500())}
        getObjectPosition={(vert) => vert ?? [0, 0, 0]}
        {...pointsProps}
      />
      <LineSegments
        verts={verts}
        linewidth={30}
        linecap={"round"}
        linejoin={"round"}
        {...linesProps}
      />
    </>
  );
};
